__turbopack_context__.v({
  "bundleProducts-container": "_0LF9fG_bundleProducts-container",
  "bundleProducts-title": "_0LF9fG_bundleProducts-title",
  "image-container": "_0LF9fG_image-container",
  "product-container": "_0LF9fG_product-container",
  "product-img": "_0LF9fG_product-img",
  "product-name": "_0LF9fG_product-name",
  "product-price": "_0LF9fG_product-price",
  "productList-container": "_0LF9fG_productList-container",
});
